var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('horizontal-nav',{attrs:{"show_display":false,"set_view":"","items":_vm.items}})}
var staticRenderFns = []

export { render, staticRenderFns }